export const AUTH_IDLE_TIMEOUT_MS = 30 * 60 * 1000;
export const AUTH_ACTIVITY_THROTTLE_MS = 30 * 1000;
export const AUTH_SESSION_EXPIRED_EVENT = 'sanspath:auth-session-expired';

export const AUTH_STORAGE_KEYS = {
  store: 'sanspath-auth',
  accessToken: 'authToken',
  legacyAccessToken: 'token',
  refreshToken: 'refreshToken',
  lastActivityAt: 'sanspath-auth-last-activity-at'
};

const canUseStorage = () => typeof window !== 'undefined' && Boolean(window.localStorage);

const readNumber = (key) => {
  if (!canUseStorage()) return null;
  const value = Number(window.localStorage.getItem(key));
  return Number.isFinite(value) && value > 0 ? value : null;
};

export const getStoredAccessToken = () => {
  if (!canUseStorage()) return null;
  return (
    window.localStorage.getItem(AUTH_STORAGE_KEYS.accessToken) ||
    window.localStorage.getItem(AUTH_STORAGE_KEYS.legacyAccessToken)
  );
};

export const getStoredRefreshToken = () => {
  if (!canUseStorage()) return null;
  return window.localStorage.getItem(AUTH_STORAGE_KEYS.refreshToken);
};

export const hasStoredAuthSession = () => Boolean(getStoredAccessToken() || getStoredRefreshToken());

export const getLastActivityAt = () => readNumber(AUTH_STORAGE_KEYS.lastActivityAt);

export const getIdleExpiresAt = () => {
  const lastActivityAt = getLastActivityAt();
  return lastActivityAt ? lastActivityAt + AUTH_IDLE_TIMEOUT_MS : null;
};

export const isIdleSessionExpired = (now = Date.now()) => {
  if (!hasStoredAuthSession()) return false;
  const lastActivityAt = getLastActivityAt();
  if (!lastActivityAt) return false;
  return now - lastActivityAt >= AUTH_IDLE_TIMEOUT_MS;
};

export const markSessionActivity = (timestamp = Date.now()) => {
  if (!canUseStorage()) return timestamp;
  window.localStorage.setItem(AUTH_STORAGE_KEYS.lastActivityAt, String(timestamp));
  return timestamp;
};

export const clearAuthStorage = () => {
  if (!canUseStorage()) return;
  window.localStorage.removeItem(AUTH_STORAGE_KEYS.store);
  window.localStorage.removeItem(AUTH_STORAGE_KEYS.accessToken);
  window.localStorage.removeItem(AUTH_STORAGE_KEYS.legacyAccessToken);
  window.localStorage.removeItem(AUTH_STORAGE_KEYS.refreshToken);
  window.localStorage.removeItem(AUTH_STORAGE_KEYS.lastActivityAt);
};

export const dispatchSessionExpired = (reason = 'idle_timeout') => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent(AUTH_SESSION_EXPIRED_EVENT, {
      detail: { reason }
    })
  );
};
